import React, { useEffect, useState } from 'react';
import { api } from '../api.js';
import { useI18n } from '../i18n/index.jsx';
import { Alert } from './ui.jsx';
import { WaIcon } from './WhatsApp.jsx';

// Account & security › "Mon WhatsApp" (migration 043): each person's own
// number (team users included), whether it's shown publicly (contact person
// on products, public team), and notifications by WhatsApp (opt-in; STOP
// in WhatsApp turns them off).
export default function MyWhatsApp({ disabled = false }) {
  const { t, errorText } = useI18n();
  const [f, setF] = useState(null);
  const [state, setState] = useState(null);
  useEffect(() => { api('/my/whatsapp').then(setF).catch(() => setF(null)); }, []);
  if (!f) return null;
  async function save(e) {
    e.preventDefault(); setState(null);
    try { setF(await api('/my/whatsapp', { method: 'PUT', body: f })); setState({ kind: 'success', text: t('common.saved') }); } catch (err) { setState({ kind: 'error', text: errorText(err) }); }
  }
  return (
    <form className="card form" onSubmit={save}>
      <h2 className="acc-card-title"><WaIcon /> {t('wa.my.title')}</h2>
      <p className="muted small">{t('wa.my.lead')}</p>
      <div className="field"><label htmlFor="my-wa">{t('wa.my.number')}</label>
        <input id="my-wa" type="tel" value={f.whatsapp} maxLength={30} placeholder="+1 438 555 0100" disabled={disabled} onChange={(e) => setF({ ...f, whatsapp: e.target.value })} />
        <p className="field-hint">{t('wa.my.numberHint')}</p></div>
      <label className="checkbox"><input type="checkbox" checked={f.public} disabled={disabled} onChange={(e) => setF({ ...f, public: e.target.checked })} /><span>{t('wa.my.public')}</span></label>
      <label className="checkbox"><input type="checkbox" checked={f.notify} disabled={disabled || !f.whatsapp} onChange={(e) => setF({ ...f, notify: e.target.checked })} /><span>{t('wa.my.notify')}{!f.apiReady && <span className="muted small"> — {t('wa.my.notifySoon')}</span>}</span></label>
      {f.optedOut && <p className="small muted">{t('wa.my.optedOut')}</p>}
      {state && <Alert kind={state.kind}>{state.text}</Alert>}
      <div><button type="submit" className="btn btn-primary" disabled={disabled}>{t('common.save')}</button></div>
    </form>
  );
}
